<template>
  <div id="mySystemList">
    <div>
      <div class="allDl m_t_20">
        <dl class="allDl_width20 allDl_span60" style="position:relative">
          <dd>
            <span>文件名:</span>
            <div>
              <input v-model="postData.FileName" type="text" class="allInput"/>
            </div>
          </dd>
          <dd>
            <span>部门:</span>
            <div>
              <input v-model="postData.BU" type="text" class="allInput"/>
            </div>
          </dd>
          <dd>
            <span>归属类别:</span>
            <div>
              <input v-model="postData.ProjectBelong" type="text" class="allInput"/>
            </div>
          </dd>
          <dd>
            <span>频率:</span>
            <div>
              <allSelect v-model="postData.UploadFrequency" :chooseData="frequencyType" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
              </allSelect>
            </div>
          </dd>
          <dt style="width: auto;">
            <button @click="getAllSerch()" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
            <button @click="toUrl(0)" class="addButton"><i class="el-icon-plus"></i><span class="m_l_5">新建</span></button>
          </dt>
        </dl>
      </div>
      <div style="max-height: calc(100vh - 270px);overflow: auto">
        <table class="allTable" cellspacing="0">
          <thead>
          <tr>
            <th style="text-align: left">ID</th>
            <th>文件名</th>
            <th>文件格式</th>
            <th>最近更新时间</th>
            <th>最近更新人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myAllList">
            <td style="text-align: left">{{item.id}}</td>
            <td>{{ item.fileName }}</td>
            <td>{{ item.fileFormat}}</td>
            <td>{{ $commonJs.returnDate(item.lastModificationTime, 'YYMMDD') }}</td>
            <td>{{ item.lastModifier }}</td>
            <td class="colorYellowF36A20" width="60">
              <div class="d_flex">
                <span class="c_p" @click="toUrl(item)">查看</span>
                <span @click="allDelt(item)" class="colorDele c_p">删除</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myHome',
  data () {
    return {
      // source: this.$axiox.CancelToken.source()
      userMenu: this.$userMenu,
      totalPage: 0,
      totalCount: 0,
      page: 1,
      postData: {
        FileName: '',
        BU: '',
        ProjectBelong: '',
        UploadFrequency: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      serchData: {
        FileName: '',
        BU: '',
        ProjectBelong: '',
        UploadFrequency: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      frequencyType: [
        {
          id: 0,
          name: '全部'
        },
        {
          id: 1,
          name: '每月'
        },
        {
          id: 2,
          name: '每年'
        },
        {
          id: 3,
          name: '不定时'
        }
      ],
      myAllList: []
    }
  },
  created () {
    this.$commonJs.addLog('查看', '系统管理', '数据规则校验', '')
    this.getAllList(1)
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    getAllSerch () {
      this.serchData = JSON.parse(JSON.stringify(this.postData))
      this.getAllList(1)
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.serchData))
      data.PageIndex = page
      let url = this.$commonJs.returnQuery('/api/FileSet/list', data)
      this.$axiox.get(url).then(msg => {
        this.myAllList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.serchData.PageSize)
        this.totalCount = msg.total
      })
    },
    toUrl (item) {
      // if (item.id && item.id !== 0) {
      //   this.$commonJs.addLog('更新', '系统管理', '数据规则校验', item.fileName)
      // }
      this.$router.push({
        name: 'myValidationDetail',
        query: {
          formId: item.id ? item.id : item
        }
      })
    },
    allDelt (item) {
      this.$commonJs.doubleComfirm({
        content: '您确定要删除此规则吗？',
        successFun: msg => {
          this.$commonJs.addLog('删除', '系统管理', '数据规则校验', item.fileName)
          this.$axiox.del('/api/FileSet/Delete?itemid=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getAllList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/mySystemList.vue